import {useEffect, useState} from 'react';

function useRemToPX(rem) {
  const parseRem = (value) =>
    typeof value === 'string' ? parseFloat(value) : value;

  const getRootFontSize = () => {
    if (typeof window === 'undefined' || !document.documentElement) {
      return 16;
    }
    return parseFloat(
      getComputedStyle(document.documentElement).fontSize || '16'
    );
  };

  const [pixels, setPixels] = useState(() => parseRem(rem) * getRootFontSize());

  useEffect(() => {
    const update = () => {
      setPixels(parseRem(rem) * getRootFontSize());
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [rem]);

  return pixels;
}

export default useRemToPX;
